import { pageHandler } from './';
const page = {
  navigate: pageHandler.navigate
};
export default page;